var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSendIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 19,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15.305 8.328a.54.54 0 0 1-.43.235.627.627 0 0 1-.43-.196l-5.82-5.469v14.727c0 .352-.313.664-.625.664-.313 0-.625-.312-.625-.664V2.898l-5.86 5.47a.581.581 0 0 1-.859-.04c-.234-.273-.234-.664.04-.898L7.57.945a.566.566 0 0 1 .82 0l6.876 6.485c.273.234.273.625.039.898Z"
})));
export { SvgSendIcon as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiM2M1NzA0OWRhODFmYTUzMmE3ODAxZGJkMjEyZWI3YjUuc3ZnIjs=";